<script setup>
import { ref } from 'vue';

import { __ } from 'JIX/gettext.js';
import { formatAsJixDate } from 'JIX/utils/date.js';
import DatePicker from 'JIX/components/DatePicker.vue';
import DsModal from 'JIX/components/ds/DsModal.vue';
import { useFormValidation, validDateAfter } from 'JIX/form_validation.js';

const startDate = defineModel('startDate', { type: Number, required: true });
const endDate = defineModel('endDate', { type: Number, required: true });
const emit = defineEmits(['datesUpdated']);

const modal = ref();

const { formEl, formData, wasValidated, validationErrors, reset, submit } = useFormValidation({
    validation: [
        validDateAfter('startDate', 'endDate'),
    ],
    onReset() {
        formData.startDate = String(startDate.value);
        formData.endDate = String(endDate.value);
    },
    async onSubmit() {
        startDate.value = Number(formData.startDate);
        endDate.value = Number(formData.endDate);
        emit('datesUpdated');
        modal.value.hide();
    },
});

function show() {
    modal.value.show();
}

defineExpose({ show });
</script>

<template>
    <DsModal
        ref="modal"
        :show="false"
        :title="__('Vis for perioden')"
        class-footer="btn-md-list"
        v-on="{ 'show.bs.modal': reset }"
        render-only-when-open
    >
        <form
            ref="formEl"
            class="row"
            :class="{ 'was-validated': wasValidated }"
        >
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label" for="date-modal-start">
                        {{ __('Startdato') }}
                    </label>
                    <DatePicker
                        id="date-modal-start"
                        name="startDate"
                        v-model="formData.startDate"
                        @blur="formData.startDate = $event.target.value"
                    />
                    <div class="invalid-feedback">
                        {{ validationErrors.startDate }}
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label" for="date-modal-end">
                        {{ __('Slutdato') }}
                    </label>
                    <DatePicker
                        id="date-modal-end"
                        name="endDate"
                        v-model="formData.endDate"
                        :options="{ endDate: formatAsJixDate(new Date()) }"
                        @blur="formData.endDate = $event.target.value"
                    />
                    <div class="invalid-feedback">
                        {{ validationErrors.endDate }}
                    </div>
                </div>
            </div>
        </form>
        <template #footer>
            <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
            >
                {{ __('Annuller') }}
            </button>
            <button
                type="button"
                class="btn btn-primary"
                @click.prevent="submit"
            >
                {{ __('Vis') }}
            </button>
        </template>
    </DsModal>
</template>
